import React, { useEffect } from "react";
// styled components
import {
  Row,
  Col,
  Divider,
  Form,
  Input,
  Button,
  DatePicker,
  InputNumber,
} from "antd";
//  hook
import { useCronogramaActividades } from "./Hooks/useCronogramaActividades";
//  redux
import { useSelector } from "react-redux";
import moment from "moment";
import { openNotification } from "../../../../utils/saveFile";
import { useEncrypt } from "../../../../hooks/useEncrypt";
import DateInput from "../../../../utils/DateInput";

interface IProps {
  cambiarPestaña: any;
  activeItem: any;
}

export const CronogramaActividades: React.FC<IProps> = (props: IProps) => {
  // redux
  // const { idConvocatoria } = useSelector((state: any) => state.convocatoria);
  const { decrypt } = useEncrypt();
  const idConvocatoria = decrypt(localStorage.getItem("id_convocatoria"));
  // hook
  const { fechas, setFechas, guardarycontinuar, cargarConvocatoria } =
    useCronogramaActividades();

  useEffect(() => {
    cargarConvocatoria();
  }, []);
  // fields form
  const fields = [
    { name: "fecha_apertura", value: fechas.fecha_apertura },
    { name: "fecha_cierre", value: fechas.fecha_cierre },
    { name: "fecha_informe", value: fechas.fecha_informe },
  ];
  return (
    <>
      <div
        className="container-fluid ps-md-4 pe-md-4 main-c7"
        style={{ marginBottom: "10%" }}
      >
        <div className="row-shadow mt-3 mb-3">
          <div className="container-row-shadow">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-8 pb-2 font-size-14px font-family-Montserrat-Regular">
                Cronograma de actividades de invitación al banco de jurados -{" "}
                <span className="font-size-10px font-color-9F0505">
                  Todos los campos son obligatorios
                </span>
              </div>
              <div className="col-8 col-md-12 col-lg-4 pb-2 d-flex justify-content-lg-end font-color-B0B0B0 font-size-12px font-family-Montserrat-Regular">
                Código de convocatoria: {idConvocatoria}
              </div>
            </div>
            <Divider style={{ marginTop: "1%", marginBottom: "1%" }} />
            <Form
              name="cronogramaactividadesjurados"
              size="large"
              layout="vertical"
              className="width-100"
              fields={fields}
              onFinish={() =>
                guardarycontinuar(props.cambiarPestaña, props.activeItem)
              }
            >
              <div className="row">
                <div className="col-12 col-md-6 col-lg-6">
                  <Form.Item
                    className="no-margin"
                    label="Fecha apertura"
                    name="fecha_apertura"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <DateInput
                      save={(fecha) => {
                        setFechas({
                          ...fechas,
                          fecha_apertura: fecha,
                        });
                      }}
                      dia={fechas.fecha_apertura?.split("-")[2] || ""}
                      mes={fechas.fecha_apertura?.split("-")[1] || ""}
                      anio={fechas.fecha_apertura?.split("-")[0] || ""}
                    />
                  </Form.Item>
                </div>

                <div className="col-12 col-md-6 col-lg-6">
                  <Form.Item
                    className="no-margin"
                    label="Fecha de cierre"
                    name="fecha_cierre"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <DateInput
                      save={(fecha) => {
                        setFechas({
                          ...fechas,
                          fecha_cierre: fecha,
                        });
                      }}
                      dia={fechas.fecha_cierre?.split("-")[2] || ""}
                      mes={fechas.fecha_cierre?.split("-")[1] || ""}
                      anio={fechas.fecha_cierre?.split("-")[0] || ""}
                    />
                  </Form.Item>
                </div>

                <div className="col-12 col-md-6 col-lg-6 mt-3">
                  <Form.Item
                    className="no-margin"
                    label="Informe de evaluación para conformación de la base de jurados."
                    name="fecha_informe"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <DateInput
                      save={(fecha) => {
                        setFechas({
                          ...fechas,
                          fecha_informe: fecha,
                        });
                      }}
                      dia={fechas.fecha_informe?.split("-")[2] || ""}
                      mes={fechas.fecha_informe?.split("-")[1] || ""}
                      anio={fechas.fecha_informe?.split("-")[0] || ""}
                    />
                  </Form.Item>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <div className="container-sticky-footer">
        <div className="row">
          <div className="col justify-content-flex-start">
            <Button
              className="button-blanco-radius"
              onClick={() =>
                props.cambiarPestaña({ ...props.activeItem, activeTab: "1" })
              }
            >
              Atrás
            </Button>
          </div>
          <div className="col justify-content-flex-end">
            <Button
              className="button-azul-radius"
              htmlType="submit"
              form="cronogramaactividadesjurados"
            >
              Continuar
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
